import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAdminAuthenticated: false,
  adminToken: null,
  adminUser: null,
  adminPermissions: null,
  users: [],
  allTrades: [],
  allDeposits: [],
  allWithdrawals: [],
  allStaff: [],
  stats: {
    totalUsers: 0,
    totalDeposits: 0,
    totalWithdrawals: 0,
    totalVolume: 0,
    activeTraders: 0,
    totalTrades: 0,
    totalDepositsCount: 0,
    totalWithdrawalsCount: 0,
  },
  loading: false,
  error: null,
  selectedUser: null,
  pendingKyc: [],
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    adminLoginStart: (state) => { state.loading = true; state.error = null; },
    adminLoginSuccess: (state, action) => {
      state.loading = false;
      state.isAdminAuthenticated = true;
      state.adminToken = action.payload.token;
      state.adminUser = action.payload.admin;
      state.adminPermissions = action.payload.admin?.permissions || null;
      state.error = null;
    },
    adminLoginFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    adminLogout: (state) => {
      state.isAdminAuthenticated = false;
      state.adminToken = null;
      state.adminUser = null;
      state.adminPermissions = null;
      state.users = [];
      state.allTrades = [];
      state.allDeposits = [];
      state.allWithdrawals = [];
      state.allStaff = [];
      state.stats = initialState.stats;
      state.selectedUser = null;
      state.pendingKyc = [];
    },
    setAdminPermissions: (state, action) => { state.adminPermissions = action.payload; },
    setUsers: (state, action) => { state.users = action.payload; },
    setAllTrades: (state, action) => { state.allTrades = action.payload; },
    setAllDeposits: (state, action) => { state.allDeposits = action.payload; },
    setAllWithdrawals: (state, action) => { state.allWithdrawals = action.payload; },
    setAllStaff: (state, action) => { state.allStaff = action.payload; },
    setStats: (state, action) => { state.stats = { ...state.stats, ...action.payload }; },
    setSelectedUser: (state, action) => { state.selectedUser = action.payload; },
    setPendingKyc: (state, action) => { state.pendingKyc = action.payload; },
    addStaff: (state, action) => { state.allStaff.push(action.payload); },
    updateStaffInList: (state, action) => {
      const idx = state.allStaff.findIndex(s => s.id === action.payload.id);
      if (idx !== -1) state.allStaff[idx] = { ...state.allStaff[idx], ...action.payload.data };
    },
    removeStaff: (state, action) => { state.allStaff = state.allStaff.filter(s => s.id !== action.payload); },
    setAdminLoading: (state, action) => { state.loading = action.payload; },
    setAdminError: (state, action) => { state.error = action.payload; },
    clearAdminError: (state) => { state.error = null; },
  },
});

export const {
  adminLoginStart, adminLoginSuccess, adminLoginFailure, adminLogout,
  setAdminPermissions, setUsers, setAllTrades, setAllDeposits, setAllWithdrawals,
  setAllStaff, setStats, setSelectedUser, setPendingKyc,
  addStaff, updateStaffInList, removeStaff,
  setAdminLoading, setAdminError, clearAdminError,
} = adminSlice.actions;

export default adminSlice.reducer;